module.exports = __webpack_public_path__ + "media/luxury-2026/waterfront-lounge-0e8e06db.jpg";